import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'searchMeta',
            'searchResults',
        ]),
    },
    data () {
        return {
            data: null,
            projectListTable: {
                name: 'ProjectListTable',
                totalCount: 0,
                columns: {
                    title: {
                        displayName: 'Project Title',
                        fieldName: 'project_title',
                        rowData: true,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        cssClass: '',
                        isSortable: true
                    },
                    applTypeCode: {
                        displayName: 'T',
                        fieldName: 'appl_type_code',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Type in Project Number',
                        isSortable: false
                    },
                    activityCode: {
                        displayName: 'Act',
                        fieldName: 'activity_code',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Activity Code in Project Number',
                        isSortable: false
                    },
                    ic_seq_no: {
                        displayName: 'Project',
                        fieldName: 'ic_serial_num',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        internalLink: true,
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'IC and Project Serial Number',
                        isSortable: true
                    },
                    support_yr: {
                        displayName: 'Year',
                        fieldName: 'support_yr_suffix_code',
                        sortFieldName: 'support_yr',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        isAlternateColumn: true,
                        internalLink: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Project Year',
                        isSortable: true
                    },
                    subproject_id: {
                        displayName: 'Sub',
                        fieldName: 'subproject_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Sub-Project ID',
                        isSortable: true
                    },
                    pi_info: {
                        displayName: 'Principal Investigator(s)/\nProject Leader(s)',
                        fieldName: 'pi_info',
                        subField: 'name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Principal Investigator(s)/ Project Leader',
                        callFunctionOnClick: true,
                        isSortable: true
                    },
                    org_name: {
                        displayName: 'Organization',
                        fieldName: 'org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Organization',
                        isSortable: true
                    },
                    fiscal_year: {
                        displayName: 'Fiscal Year',
                        fieldName: 'fiscal_year',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Fiscal Year',
                        isSortable: true
                    },
                    admin_icd_long_abbr: {
                        displayName: 'Admin IC',
                        fieldName: 'admin_icd_long_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Admin IC/Agency',
                        isSortable: true
                    },
                    funding_ic: {
                        displayName: 'Funding IC',
                        fieldName: 'funding',
                        subField: 'ic',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Funding by IC',
                        isSortable: true
                    },
                    funding_cost: {
                        displayName: 'FY Total\nCost by IC',
                        fieldName: 'funding',
                        subField: 'total_cost',
                        formatType: '$',
                        cssClass: 'rightAlign',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        helpText: 'FY Total Cost by IC/Agency',
                        isSortable: true
                    },
                    actionItems: {
                        displayName: 'Similar\nProjects',
                        fieldName: '',
                        fieldType: 'button',
                        refURL: '{{search_id}}/project-details/{{field0}}#similar-Projects',
                        urlFields: ['appl_id'],
                        internalLink: true,
                        isAlternateColumn: false,
                        isVisible: true,
                        disabled: false,
                        helpText: '',
                        isSortable: false
                    },
                    matchScore: {
                        displayName: 'Match',
                        fieldName: 'match_score',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: false,
                        cssClass: 'rightAlign',
                        helpText: 'Match Score'
                    },
                },
                totalColumns: 12,
                offset: 0,
                limit: 50,
                sortField: "",
                sortOrder: 'asc',
                loadingMoreData: false,
                isLoading: false
            },
            projectHistoryTable: {
                name: 'projectHistoryTable',
                totalCount: 0,
                columns: {
                    title: {
                        displayName: 'Project Title',
                        fieldName: 'project_title',
                        rowData: true,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: ''
                    },
                    fullProjectNum: {
                        displayName: 'Project Number',
                        fieldName: 'full_project_num',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        internalLink: true,
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    subproject_id: {
                        displayName: 'Sub',
                        fieldName: 'subproject_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Sub-Project ID'
                    },
                    pi_info: {
                        displayName: 'Principal Investigator(s)/\nProject Leader(s)',
                        fieldName: 'pi_info',
                        subField: 'name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Principal Investigator(s)/ Project Leader',
                        callFunctionOnClick: true
                    },
                    org_name: {
                        displayName: 'Organization',
                        fieldName: 'org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Organization'
                    },
                    fiscal_year: {
                        displayName: 'Fiscal Year',
                        fieldName: 'fiscal_year',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Fiscal Year'
                    },
                    admin_icd_long_abbr: {
                        displayName: 'Admin IC',
                        fieldName: 'admin_icd_long_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Admin IC/Agency'
                    },
                    funding_ic: {
                        displayName: 'Funding IC',
                        fieldName: 'funding',
                        subField: 'ic',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    funding_cost: {
                        displayName: 'FY Total\nCost by IC',
                        fieldName: 'funding',
                        subField: 'total_cost',
                        formatType: '$',
                        cssClass: 'rightAlign',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        helpText: 'FY Total Cost by IC/Agency'
                    }
                },
                totalColumns: 9,
                offset: 0,
                limit: 50,
                sortField: "FiscalYear",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            subProjectsTable: {
                name: 'subProjectsTable',
                totalCount: 0,
                columns: {
                    title: {
                        displayName: 'Project Title',
                        fieldName: 'project_title',
                        rowData: true,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: ''
                    },
                    fullProjectNum: {
                        displayName: 'Project Number',
                        fieldName: 'full_project_num',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        internalLink: true,
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    subproject_id: {
                        displayName: 'Sub',
                        fieldName: 'subproject_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Sub-Project ID'
                    },
                    pi_info: {
                        displayName: 'Principal Investigator(s)/\nProject Leader(s)',
                        fieldName: 'pi_info',
                        subField: 'name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Principal Investigator(s)/ Project Leader',
                        callFunctionOnClick: true
                    },
                    org_name: {
                        displayName: 'Organization',
                        fieldName: 'org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Organization'
                    },
                    fiscal_year: {
                        displayName: 'Fiscal Year',
                        fieldName: 'fiscal_year',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Fiscal Year'
                    },
                    admin_icd_long_abbr: {
                        displayName: 'Admin IC',
                        fieldName: 'admin_icd_long_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Admin IC/Agency'
                    },
                    funding_cost: {
                        displayName: 'FY Total\nCost by IC',
                        fieldName: 'funding',
                        subField: 'total_cost',
                        formatType: '$',
                        cssClass: 'rightAlign',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        helpText: 'FY Total Cost by IC/Agency'
                    }
                },
                totalColumns: 9,
                offset: 0,
                limit: 50,
                sortField: "",
                sortOrder: 'asc',
                loadingMoreData: false,
                isLoading: false
            },
            publicationTable: {
                name: 'Projects',
                totalCount: 0,
                columns: {
                    coreProjectNumber: {
                        displayName: 'Core Project Number',
                        fieldName: 'core_project_num',
                        refURL: '{{search_id}}/publications/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        headerClass: 'no-break',
                        internalLink: true,
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    title: {
                        displayName: 'Title (Link to full-text in PubMed Central)',
                        rowData: true,
                        fieldName: 'pub_title',
                        refURLField: 'pub_title_link',
                        sortOrder: 'asc',
                        conditionalField: 'pmc_id',
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    journal: {
                        displayName: 'Journal (Link to PubMed abstract)',
                        fieldName: 'journal_title',
                        refURLField: 'journal_title_link',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Journal'
                    },
                    authors: {
                        displayName: 'Authors',
                        fieldName: 'author_list',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        truncateData: true,
                        helpText: 'Authors'
                    },
                    pubYear: {
                        displayName: 'Publication Year',
                        fieldName: 'pub_year',
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Publication Year'
                    },
                    similarPublications: {
                        displayName: 'Similar\nPublications',
                        fieldType: 'icon',
                        icons: [
                            {
                                name: '/img/pubmed.png',
                                type: 'image',
                                cssStyle: "height: 20px; margin-bottom:6px",
								fieldName: 'related_pub_med_links',
                                alt: "similar publications"
                            },
                            {
                                name: 'fab fa-google',
                                cssStyle: "color:#c32d2d",
                                fieldName: 'related_pub_med_google'
                            }
                        ],
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    citedBy: {
                        displayName: 'CitedBy',
                        fieldType: 'icon',
                        icons: [
                            {
                                name: 'fas fa-university',
                                fieldName: 'article_pub_med_central'
                            },
                            {
                                name: 'fab fa-google',
                                cssStyle: "color:#c32d2d",
                                fieldName: 'article_citing_google'
                            }
                        ],
                        cssClass: 'centerAlign',
                        isVisible: true,
                        helpText: ''
                    },
                    relativeCitationRatio: {
                        displayName: 'iCite RCR',
                        fieldName: 'relative_citation_ratio',
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'iCite RCR',
                        formatType: 'round',
                        headerClass: 'no-break'
                    }
                },
                exportColumns: {
                    coreProjectNumber: {
                        displayName: 'Core Project Number',
                        fieldName: 'core_project_num',
                        exportOnly: true
                    },
                    author_affiliation: {
                        displayName: 'Affilation',
                        fieldName: 'author_affiliation',
                        exportOnly: true
                    },
                    author_list: {
                        displayName: 'Authors',
                        fieldName: 'author_list',
                        exportOnly: true
                    },
                    country: {
                        displayName: 'Country',
                        fieldName: 'country',
                        exportOnly: true
                    },
                    issn: {
                        displayName: 'ISSN',
                        fieldName: 'issn',
                        exportOnly: true
                    },
                    journal_issue: {
                        displayName: 'Journal Issue',
                        fieldName: 'journal_issue',
                        exportOnly: true
                    },
                    journal_title: {
                        displayName: 'Journal (Link to PubMed abstract)',
                        fieldName: 'journal_title',
                        refURLField: 'journal_title_link',
                        exportOnly: true
                    },
                    journal_title_abbr: {
                        displayName: 'Journal Title ABBR',
                        fieldName: 'journal_title_abbr',
                        exportOnly: true
                    },
                    journal_volume: {
                        displayName: 'Journal Volume',
                        fieldName: 'journal_volume',
                        exportOnly: true
                    },
                    language: {
                        displayName: 'Language',
                        fieldName: 'language',
                        exportOnly: true
                    },
                    page_number: {
                        displayName: 'Page Number',
                        fieldName: 'page_number',
                        exportOnly: true
                    },
                    pmc_id: {
                        displayName: 'PMC ID',
                        fieldName: 'pmc_id',
                        exportOnly: true
                    },
                    pm_id: {
                        displayName: 'PMID',
                        fieldName: 'pm_id',
                        exportOnly: true
                    },
                    pub_date: {
                        displayName: 'PUB Date',
                        fieldName: 'pub_date',
                        exportOnly: true
                    },
                    pub_title: {
                        displayName: 'Title (Link to full-text in PubMed Central)',
                        fieldName: 'pub_title',
                        exportOnly: true,
                        refURLField: 'pub_title_link'
                    },
                    pub_year: {
                        displayName: 'PUB Year',
                        fieldName: 'pub_year',
                        exportOnly: true
                    },
                    RelatedPubMed: {
                        displayName: 'Related Publications in PubMed',
                        fieldName: '',
                        fieldText: 'Related, PubMed',
                        exportOnly: true,
                        refURLField: 'related_pub_med_links'
                    },
                    RelatedGoogle: {
                        displayName: 'Related Publications in Google Scholar',
                        fieldName: '',
                        fieldText: 'Related, Google Scholar',
                        exportOnly: true,
                        refURLField: 'related_pub_med_google'
                    },
                    ArticlesPubMed: {
                        displayName: 'Articles Citing from PubMed Central',
                        fieldName: '',
                        fieldText: 'Cited By, PMC',
                        exportOnly: true,
                        refURLField: 'article_pub_med_central'
                    },
                    ArticlesGoogle: {
                        displayName: 'Articles Citing from Google Scholar',
                        fieldName: '',
                        fieldText: 'Cited By, Google',
                        exportOnly: true,
                        refURLField: 'article_citing_google'
                    },
                    relativeCitationRatio: {
                        displayName: 'iCite RCR',
                        fieldName: 'relative_citation_ratio',
                        exportOnly: true,
                    }
                },
                totalColumns: 12,
                offset: 0,
                limit: 50,
                sortField: "pub_year",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            patentTable: {
                name: 'patentTable',
                totalCount: 0,
                columns: {
                    coreProjectNumber: {
                        displayName: 'Core NIH Project Number',
                        fieldName: 'core_project_num',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    patentId: {
                        displayName: 'Patent Number',
                        fieldName: 'patent_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Patent Number'
                    },
                    patentTitle: {
                        displayName: 'Patent Title',
                        fieldName: 'patent_title',
                        URLFieldName: 'patent_title_url',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        internalLink: false,
                        isSortable: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Patent Title'
                    },
                    patentOwner: {
                        displayName: 'Patent Owner',
                        fieldName: 'patent_org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Patent Owner',
                        dataToolTip: 'The organization or individual(s) name listed is the patent owner, which may differ from the prime grant or contract awardee institution.'
                    },
                    primaryAgency: {
                        displayName: 'Primary Agency',
                        fieldName: 'primary_agency',
                        URLFieldName: 'primary_agency_url',
                        internalLink: false,
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Primary Agency',
                        dataToolTip: 'The agency that has primarily funded, and entirely manages the patent. iEdison Agency Contact information link provided.'
                    }
                },
                exportColumns: {
                    coreProjectNumber: {
                        displayName: 'Core NIH Project Number',
                        fieldName: 'core_project_num',
                        exportOnly: true
                    },
                    patentId: {
                        displayName: 'Patent Number',
                        fieldName: 'patent_id',
                        exportOnly: true
                    },
                    patentTitle: {
                        displayName: 'Patent Title',
                        fieldName: 'patent_title',
                        exportOnly: true
                    },
                    patentTitleURL: {
                        displayName: 'Patent Title Link',
                        fieldName: '',
                        refURLField: 'patent_title_url',
                        exportOnly: true
                    },
                    patentOwner: {
                        displayName: 'Patent Owner',
                        fieldName: 'patent_org_name',
                        exportOnly: true
                    },
                    primaryAgency: {
                        displayName: 'Primary Agency',
                        fieldName: 'primary_agency',
                        exportOnly: true
                    },
                    primaryAgencyLink: {
                        displayName: 'Primary Agency Link',
                        fieldName: '',
                        refURLField: 'primary_agency_url',
                        exportOnly: true
                    }
                },
                totalColumns: 5,
                offset: 0,
                limit: 50,
                sortField: "patent_title",
                sortOrder: 'asc',
                loadingMoreData: false,
                isLoading: false
            },
            clinicalStudyTable: {
                name: 'clinicalStudyTable',
                totalCount: 0,
                columns: {
                    coreProjectNumber: {
                        displayName: 'Core NIH Project Number',
                        fieldName: 'core_project_num',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    clinicalStudiesId: {
                        displayName: 'ClinicalTrials.gov ID',
                        fieldName: 'nct_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'ClinicalTrials.gov ID'
                    },
                    study: {
                        displayName: 'Study',
                        fieldName: 'study_title',
                        refURLField: 'study_title_url',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        internalLink: false,
                        isSortable: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Study'
                    },
                    studyStatus: {
                        displayName: 'Study Status',
                        fieldName: 'study_status',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Study Status',
                    }
                },
                exportColumns: {
                    coreProjectNumber: {
                        displayName: 'Core NIH Project Number',
                        fieldName: 'core_project_num',
                        exportOnly: true
                    },
                    clinicalStudiesId: {
                        displayName: 'ClinicalTrials.gov ID',
                        fieldName: 'nct_id',
                        exportOnly: true
                    },
                    study: {
                        displayName: 'Study',
                        fieldName: 'study_title',
                        exportOnly: true
                    },
                    studyStatus: {
                        displayName: 'Study Status',
                        fieldName: 'study_status',
                        exportOnly: true
                    }
                },
                totalColumns: 5,
                offset: 0,
                limit: 50,
                sortField: "study_title",
                sortOrder: 'asc',
                loadingMoreData: false,
                isLoading: false
            },
            similarProjectTable: {
                name: 'similarProjectTable',
                totalCount: 0,
                columns: {
                    title: {
                        displayName: 'Project Title',
                        fieldName: 'project_title',
                        rowData: true,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: ''
                    },
                    matchScore: {
                        displayName: 'Match Score',
                        fieldName: 'match_score',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Match Score'
                    },
                    fullProjectNum: {
                        displayName: 'Project Number',
                        fieldName: 'full_project_num',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        internalLink: true,
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    subproject_id: {
                        displayName: 'Sub',
                        fieldName: 'subproject_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Sub-Project ID'
                    },
                    pi_info: {
                        displayName: 'Principal Investigator(s)/\nProject Leader(s)',
                        fieldName: 'pi_info',
                        subField: 'name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Principal Investigator(s)/ Project Leader',
                        callFunctionOnClick: true
                    },
                    org_name: {
                        displayName: 'Organization',
                        fieldName: 'org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Organization'
                    },
                    fiscal_year: {
                        displayName: 'Fiscal Year',
                        fieldName: 'fiscal_year',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Fiscal Year'
                    },
                    admin_icd_long_abbr: {
                        displayName: 'Admin IC',
                        fieldName: 'admin_icd_long_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        isSortable: true,
                        helpText: 'Admin IC/Agency'
                    },
                    funding_ic: {
                        displayName: 'Funding IC',
                        fieldName: 'funding',
                        subField: 'ic',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    funding_cost: {
                        displayName: 'FY Total\nCost by IC',
                        fieldName: 'funding',
                        subField: 'total_cost',
                        formatType: '$',
                        cssClass: 'rightAlign',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        helpText: 'FY Total Cost by IC/Agency'
                    }
                },
                totalColumns: 9,
                offset: 0,
                limit: 50,
                sortField: "match_score",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            matchMakerListTable: {
                name: 'matchMakerListTable',
                totalCount: 0,
                columns: {
                    title: {
                        displayName: 'Project Title',
                        fieldName: 'project_title',
                        rowData: true,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: ''
                    },
                    applTypeCode: {
                        displayName: 'T',
                        fieldName: 'appl_type_code',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Type in Project Number'
                    },
                    activityCode: {
                        displayName: 'Act',
                        fieldName: 'activity_code',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        internalLink: true,
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Activity Code in Project Number'
                    },
                    ic_seq_no: {
                        displayName: 'Project',
                        fieldName: 'ic_serial_num',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        internalLink: true,
                        isAlternateColumn: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'IC and Project Serial Number'
                    },
                    support_yr: {
                        displayName: 'Year',
                        fieldName: 'support_yr_suffix_code',
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        alternateField: 'contract_num',
                        isAlternateColumn: true,
                        internalLink: true,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Project Year'
                    },
                    subproject_id: {
                        displayName: 'Sub',
                        fieldName: 'subproject_id',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Sub-Project ID'
                    },
                    pi_info: {
                        displayName: 'Principal Investigator(s)/\nProject Leader(s)',
                        fieldName: 'pi_info',
                        subField: 'name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Principal Investigator(s)/ Project Leader',
                        callFunctionOnClick: true
                    },
                    org_name: {
                        displayName: 'Organization',
                        fieldName: 'org_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Organization'
                    },
                    fiscal_year: {
                        displayName: 'Fiscal Year',
                        fieldName: 'fiscal_year',
                        isAlternateColumn: false,
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Fiscal Year'
                    },
                    admin_icd_long_abbr: {
                        displayName: 'Admin IC',
                        fieldName: 'admin_icd_long_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Admin IC/Agency'
                    },
                    funding_ic: {
                        displayName: 'Funding IC',
                        fieldName: 'funding',
                        subField: 'ic',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Funding By IC'
                    },
                    funding_cost: {
                        displayName: 'FY Total\nCost by IC',
                        fieldName: 'funding',
                        subField: 'total_cost',
                        formatType: '$',
                        cssClass: 'rightAlign',
                        isAlternateColumn: false,
                        isSortable: true,
                        sortOrder: 'desc',
                        isVisible: true,
                        helpText: 'FY Total Cost by IC/Agency'
                    },
                    actionItems: {
                        displayName: 'Similar\nProjects',
                        fieldName: '',
                        fieldType: 'button',
                        refURL: '{{search_id}}/project-details/{{field0}}#similar-Projects',
                        urlFields: ['appl_id'],
                        internalLink: true,
                        isAlternateColumn: false,
                        isVisible: true,
                        disabled: false,
                        helpText: ''
                    },
                    matchScore: {
                        displayName: 'Match',
                        fieldName: 'match_score',
                        isAlternateColumn: false,
                        isSortable: true,
                        sortOrder: 'desc',
                        isVisible: true,
                        cssClass: 'rightAlign',
                        helpText: 'Match Score'
                    },
                },
                totalColumns: 12,
                offset: 0,
                limit: 100,
                sortField: "match_score",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            publicationResultsTable: {
                name: 'Publication Search Results',
                totalCount: 0,
                columns: {
                    coreProjects: {
                        displayName: 'Core Project Number(s)',
                        fieldName: 'coreprojects',
                        refURL: '/publications/{{search_id}}/project-details/{{field0}}',
                        urlFields: ['applids'],
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        headerClass: 'no-break',
                        internalLink: true,
                        cssClass: '',
                        truncateData: true,
                        formatType: 'link_array',
                        helpText: 'Project Number'
                    },
                    title: {
                        displayName: 'Title (Link to full-text in PubMed Central)',
                        rowData: true,
                        fieldName: 'pub_title',
                        refURLField: 'pub_title_link',
                        sortOrder: 'asc',
                        conditionalField: 'pmc_id',
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    journal: {
                        displayName: 'Journal (Link to PubMed abstract)',
                        fieldName: 'journal_title',
                        refURLField: 'journal_title_link',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Journal'
                    },
                    authors: {
                        displayName: 'Authors',
                        fieldName: 'author_list',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        truncateData: true,
                        helpText: 'Authors'
                    },
                    pubYear: {
                        displayName: 'Publication Year',
                        fieldName: 'pub_year',
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'Publication Year'
                    },
                    similarPublications: {
                        displayName: 'Similar\nPublications',
                        fieldType: 'icon',
                        icons: [
                            {
                                name: '/img/pubmed.png',
                                type: 'image',
                                cssStyle: "height: 20px; margin-bottom:6px",
								fieldName: 'related_pub_med_links',
                                alt: "similar publications"
                            },
                            {
                                name: 'fab fa-google',
                                cssStyle: "color:#c32d2d",
                                fieldName: 'related_pub_med_google'
                            }
                        ],
                        isVisible: true,
                        cssClass: '',
                        helpText: ''
                    },
                    citedBy: {
                        displayName: 'CitedBy',
                        fieldType: 'icon',
                        icons: [
                            {
                                name: 'fas fa-university',
                                fieldName: 'article_pub_med_central'
                            },
                            {
                                name: 'fab fa-google',
                                cssStyle: "color:#c32d2d",
                                fieldName: 'article_citing_google'
                            }
                        ],
                        cssClass: 'centerAlign',
                        isVisible: true,
                        helpText: ''
                    },
                    relativeCitationRatio: {
                        displayName: 'iCite RCR',
                        fieldName: 'relative_citation_ratio',
                        sortOrder: 'desc',
                        isVisible: true,
                        isSortable: true,
                        cssClass: '',
                        helpText: 'iCite RCR',
                        formatType: 'round',
                        headerClass: 'no-break'
                    }
                },
                exportColumns: {
                    coreProjectNumber: {
                        displayName: 'Core Project Number',
                        fieldName: 'coreprojects',
                        exportOnly: true
                    },
                    author_affiliation: {
                        displayName: 'Affilation',
                        fieldName: 'author_affiliation',
                        exportOnly: true
                    },
                    author_list: {
                        displayName: 'Authors',
                        fieldName: 'author_list',
                        exportOnly: true
                    },
                    country: {
                        displayName: 'Country',
                        fieldName: 'country',
                        exportOnly: true
                    },
                    issn: {
                        displayName: 'ISSN',
                        fieldName: 'issn',
                        exportOnly: true
                    },
                    journal_issue: {
                        displayName: 'Journal Issue',
                        fieldName: 'journal_issue',
                        exportOnly: true
                    },
                    journal_title: {
                        displayName: 'Journal (Link to PubMed abstract)',
                        fieldName: 'journal_title',
                        refURLField: 'journal_title_link',
                        exportOnly: true
                    },
                    journal_title_abbr: {
                        displayName: 'Journal Title ABBR',
                        fieldName: 'journal_title_abbr',
                        exportOnly: true
                    },
                    journal_volume: {
                        displayName: 'Journal Volume',
                        fieldName: 'journal_volume',
                        exportOnly: true
                    },
                    language: {
                        displayName: 'Language',
                        fieldName: 'language',
                        exportOnly: true
                    },
                    page_number: {
                        displayName: 'Page Number',
                        fieldName: 'page_number',
                        exportOnly: true
                    },
                    pmc_id: {
                        displayName: 'PMC ID',
                        fieldName: 'pmc_id',
                        exportOnly: true
                    },
                    pmid: {
                        displayName: 'PMID',
                        fieldName: 'pmid',
                        exportOnly: true
                    },
                    pub_date: {
                        displayName: 'PUB Date',
                        fieldName: 'pub_date',
                        exportOnly: true
                    },
                    pub_title: {
                        displayName: 'Title (Link to full-text in PubMed Central)',
                        fieldName: 'pub_title',
                        exportOnly: true,
                        refURLField: 'pub_title_link'
                    },
                    pub_year: {
                        displayName: 'PUB Year',
                        fieldName: 'pub_year',
                        exportOnly: true
                    },
                    RelatedPubMed: {
                        displayName: 'Related Publications in PubMed',
                        fieldName: '',
                        fieldText: 'Related, PubMed',
                        exportOnly: true,
                        refURLField: 'related_pub_med_links'
                    },
                    RelatedGoogle: {
                        displayName: 'Related Publications in Google Scholar',
                        fieldName: '',
                        fieldText: 'Related, Google Scholar',
                        exportOnly: true,
                        refURLField: 'related_pub_med_google'
                    },
                    ArticlesPubMed: {
                        displayName: 'Articles Citing from PubMed Central',
                        fieldName: '',
                        fieldText: 'Cited By, PMC',
                        exportOnly: true,
                        refURLField: 'article_pub_med_central'
                    },
                    ArticlesGoogle: {
                        displayName: 'Articles Citing from Google Scholar',
                        fieldName: '',
                        fieldText: 'Cited By, Google',
                        exportOnly: true,
                        refURLField: 'article_citing_google'
                    },
                    relativeCitationRatio: {
                        displayName: 'iCite RCR',
                        fieldName: 'relative_citation_ratio',
                        exportOnly: true,
                    }
                },
                totalColumns: 12,
                offset: 0,
                limit: 50,
                sortField: "pub_year",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            PressReleaseTable: {
                name: 'PressReleaseTable',
                totalCount: 0,
                columns: {
                    grant_num: {
                        displayName: 'Grant Number',
                        fieldName: 'grant_nums',
                        sortFieldName: 'grant_num.keyword',
                        isAlternateColumn: false,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_ids'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        internalLink: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Grant Number'
                    },
                    news: {
                        displayName: 'News',
                        fieldName: 'description',
                        sortFieldName: 'description.keyword',
                        isAlternateColumn: false,
                        refURLField: 'news_link',
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'News'
                    },
                    journl_link: {
                        displayName: 'Journal Article',
                        fieldType: 'icon',
                        icons: [
                            {
                                name: 'fas fa-book-open',
                                refURLField: 'journl_link'
                            }
                        ],
                        isVisible: true,
                        cssClass: '',
                        helpText: '',
                        isSortable: false,
                        internalLink: false
                    },
                    journal_title: {
                        displayName: 'PubMed Abstract',
                        fieldType: 'icon',
                        fieldName: 'pmid',
                        icons: [
                            {
                                name: 'fas fa-book-medical',
                                refURLField: 'pub_med_link'
                            }
                        ],
                        isVisible: true,
                        isSortable: false,
                        internalLink: false
                    },
                    date_added: {
                        displayName: 'Release Date',
                        fieldName: 'date_added',
                        internalLink: false,
                        isAlternateColumn: false,
                        formatType: 'mon_yyyy',
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: 'date',
                        helpText: 'Release Date'
                    }
                },
                totalColumns: 5,
                offset: 0,
                limit: 50,
                sortField: null,
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false,
                isCountLoading: false
            },
            ResearchMattersTable: {
                name: 'ResearchMattersTable',
                totalCount: 0,
                columns: {
                    grant_num: {
                        displayName: 'Grant Number',
                        fieldName: 'grant_nums',
                        sortFieldName: 'grant_num.keyword',
                        isAlternateColumn: false,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        internalLink: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Grant Number'
                    },
                    news: {
                        displayName: 'News',
                        fieldName: 'description',
                        sortFieldName: 'description.keyword',
                        isAlternateColumn: false,
                        refURLField: 'news_link',
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'News'
                    },
                    journal_title: {
                        displayName: 'PubMed Abstract',
                        fieldType: 'icon',
                        fieldName: 'pmid',
                        icons: [
                            {
                                name: 'fas fa-book-medical',
                                refURLField: 'pub_med_link'
                            }
                        ],
                        isVisible: true,
                        isSortable: false,
                        internalLink: false
                    },
                    date_added: {
                        displayName: 'Release Date',
                        fieldName: 'date_added',
                        internalLink: false,
                        isAlternateColumn: false,
                        formatType: 'mon_yyyy',
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: 'date',
                        helpText: 'Release Date'
                    }
                },
                totalColumns: 5,
                offset: 0,
                limit: 50,
                sortField: null,
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false,
                isCountLoading: false
            },
            AIRSTable: {
                name: 'AIRSTable',
                totalCount: 0,
                columns: {
                    grant_num: {
                        displayName: 'Project Number',
                        fieldName: 'grant_num',
                        sortFieldName: 'project_num.keyword',
                        isAlternateColumn: false,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        internalLink: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    news: {
                        displayName: 'Title',
                        fieldName: 'description',
                        sortFieldName: 'description.keyword',
                        isAlternateColumn: false,
                        refURL: '{{report_url}}/recovery/reports?reportName=investment&id={{field0}}',
                        urlFields: ['id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Title'
                    }
                },
                totalColumns: 2,
                offset: 0,
                limit: 50,
                sortField: 'date_added',
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false,
                isCountLoading: false
            },
            ARRATable: {
                name: 'ARRATable',
                totalCount: 0,
                columns: {
                    grant_num: {
                        displayName: 'Project Number',
                        fieldName: 'grant_num',
                        sortFieldName: 'project_num.keyword',
                        isAlternateColumn: false,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        internalLink: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    news: {
                        displayName: 'Title',
                        fieldName: 'description',
                        sortFieldName: 'description.keyword',
                        isAlternateColumn: false,
                        refURL: '{{report_url}}/recovery/reports?reportName=story&id={{field0}}',
                        urlFields: ['id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Title',
                        internalLink: false
                    }
                },
                totalColumns: 2,
                offset: 0,
                limit: 50,
                sortField: 'date_added',
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false,
                isCountLoading: false
            },
            AIMRSTable: {
                name: 'AIMRSTable',
                totalCount: 0,
                columns: {
                    grant_num: {
                        displayName: 'Project Number',
                        fieldName: 'grant_num',
                        sortFieldName: 'grant_num.keyword',
                        isAlternateColumn: false,
                        refURL: '{{search_id}}/project-details/{{field0}}',
                        urlFields: ['appl_id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        internalLink: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Project Number'
                    },
                    news: {
                        displayName: 'Title',
                        fieldName: 'description',
                        sortFieldName: 'description.keyword',
                        isAlternateColumn: false,
                        refURL: '{{report_url}}/recovery/reports?reportName=impact&id={{field0}}',
                        urlFields: ['id'],
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: 'no-break',
                        cssClass: '',
                        helpText: 'Title',
                        internalLink: false
                    }
                },
                totalColumns: 2,
                offset: 0,
                limit: 50,
                sortField: 'date_added',
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false,
                isCountLoading: false
            }
        };
    },
    mounted () {
    },
    methods: {
    }
}